import { Box, Flex, HStack, Spacer, useMediaQuery } from "native-base";
import CryptoJS from "crypto-js";
import InputField from "../../../../components/input";
import { MOBILE_VIEW_WIDTH } from "../../../../utils/screens";
import Dropdown from "../../../../components/dropdown";
import FormHeader from "../../../../components/formHeader";
import MultiSelectDropdown from "../../../../components/multiselect";
import CommonBadge from "../../../../components/badge";
import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import NewTextAreaField from "../../../../components/textArea/newTextArea";
import config from "../../../../utils/config";
import { getQuizzesAPI } from '../../../../api/apis/quicklinks'

const MiceBasicDetails = forwardRef(
  (
    {
      miceFormData,
      setMiceFormData,
      miceErrorFormData,
      setDefaultErrorFrom,
      miceAgency,
      forceRemount,
      childref,
      showModal,
      edit = false,
      showToaster,
    },
    ref
  ) => {
    const [MobileWindow] = useMediaQuery({
      maxWidth: MOBILE_VIEW_WIDTH,
    });
    const [miceUpdateFormData, setMiceUpdateFormData] = useState(miceFormData);
    const [quizOptions, setQuizOptions] = useState([]);
    const bytes = CryptoJS.AES.decrypt(
      sessionStorage.getItem("content"),
      config.userKey
    );
    const jsonString = bytes.toString(CryptoJS.enc.Utf8);
    const userInfo = JSON.parse(jsonString);
    const locationOptions = [
      { id: "1", value: "within_india", label: "Within India" },
      { id: "2", value: "outside_india", label: "Outside India" },
    ];

    const hotelOptions = [
      { id: "1", value: "with_hotel", label: "With Hotel" },
      { id: "2", value: "without_hotel", label: "Without Hotel" },
    ];

    const isPremiumOptions = [
      { id: "1", value: 'yes', label: "Yes" },
      { id: "2", value: 'no', label: "No" },
    ]

        // Add "Self" option to the agency list
    const agencyOptions = [
      { 
        id: "self", 
        value: "self", 
        label: "Self",
        isSelfOption: true 
      },
      ...(miceAgency || [])
    ];

    // Fetch quiz options on component mount
    // useEffect(() => {
    //   const fetchQuizOptions = async () => {
    //     try {
    //       const response = await getQuizzesAPI();
    //       if (response && response.data) {
    //         const mappedQuizOptions = response.data.data.data.map((quiz) => ({
    //           id: quiz._id,
    //           value: quiz._id,
    //           label: quiz.title
    //         }));
    //         setQuizOptions(mappedQuizOptions);
    //       }
    //     } catch (error) {
    //       console.error("Error fetching quiz options:", error);
    //       setQuizOptions([]);
    //     }
    //   };

    //   fetchQuizOptions();
    // }, []);

    useEffect(() => {
      if (showModal) {
        let data = { ...miceUpdateFormData };
        let dataKeys = [
          "additional_info",
          "agency",
          "conference_location",
          "business",
          "coordinator_name",
          "email",
          "phone",
          "coordinator_name_2",
          "email_2",
          "phone_2",
          "coordinator_name_3",
          "email_3",
          "phone_3",
          "other_requirements",
          "is_premium",
          "quiz_id"
        ];
        Object.keys(miceUpdateFormData).map((key) => {
          if (!dataKeys.includes(key)) delete data[key];
        });
        setMiceUpdateFormData(data);
      } else {
        // Preserve existing selections when coming back
        const updatedData = { ...miceFormData };
        if (miceUpdateFormData?.agency && miceUpdateFormData?.agency?.length > 0) {
          updatedData.agency = miceUpdateFormData?.agency;
          updatedData.self_agency_approval = miceUpdateFormData?.self_agency_approval;
        }
        if (miceUpdateFormData?.is_premium !== undefined) {
          updatedData.is_premium = miceUpdateFormData?.is_premium;
        }
        if (miceUpdateFormData?.quiz_id !== undefined) {
          updatedData.quiz_id = miceUpdateFormData?.quiz_id;
        }
        setMiceUpdateFormData(updatedData);
      }
    }, [showModal, miceFormData]);

    const onInputChange = (e, eName) => {
      setDefaultErrorFrom();
      let detail = { ...miceUpdateFormData };
      let validAgencies = [];

      if (['conference_location', 'hotel_requirement', 'agency', 'is_premium', 'quiz_id'].includes(eName)) {
        if (eName === 'hotel_requirement' || eName === 'conference_location') {
          detail['additional_info'][eName] = e;
        } else if (eName === 'agency') {
          // New handling for agency field with "Self" option support
          const hasSelfOption = e?.some((item) => item.isSelfOption);
          let isBlocked = false;

          if (hasSelfOption) {
            // If "Self" is selected, only keep "Self" and disable other options
            detail[eName] = e.filter((item) => item.isSelfOption);
            detail['self_agency_approval'] = true;
          } else {
            e?.map((list) => {
              if (list.blocked) {
                isBlocked = true;
              } else {
                validAgencies.push(list);
              }
            });

            if (isBlocked) {
              showToaster();
            }

            detail[eName] = validAgencies;
            detail['self_agency_approval'] = false;
          }
        }
        else if (eName === 'is_premium') {
          detail[eName] = e === 'yes';
        }
        else if (eName === 'quiz_id') {
          detail[eName] = e;
        }
        setMiceUpdateFormData(detail);
        return;
      }

      let value = e.target.value;
      if (["boarding_from", "destination_to"].includes(eName)) {
        detail["additional_info"][eName] = value;
      } else {
        if ((eName === "phone" || eName === "phone_2" || eName === "phone_3") && (isNaN(value) || value.length > 10)) {
          return;
        }
        detail[eName] = value;
      }
      setMiceUpdateFormData(detail);
    };

    const handleSelectedValues = (ind) => {
      let detail = { ...miceUpdateFormData };
      detail["agency"] = miceUpdateFormData.agency?.filter(
        (item) => item.id !== ind
      );

           // If removing "Self", remove the self_agency_approval flag
      if (ind === "self") {
        delete detail["self_agency_approval"];
      }

      setMiceUpdateFormData(detail);
      return;
    };

    const onSubmitDataInput = () => {
      // Ensure is_premium is always a boolean in the final payload
      const finalData = { ...miceUpdateFormData };
      if (typeof finalData.is_premium === 'string' && finalData.is_premium !== '') {
        finalData.is_premium = finalData.is_premium === 'yes';
      }
      
      // Ensure self_agency_approval is properly set based on agency selection
      if (finalData?.agency && finalData?.agency?.length > 0) {
        const hasSelfOption = finalData?.agency?.some((item) => item?.isSelfOption);
        if (hasSelfOption) {
          finalData.self_agency_approval = true;
        } else {
          finalData.self_agency_approval = false;
        }
      }
      
      return finalData;
    };

    useImperativeHandle(ref, () => ({
      onSubmitDataInput,
    }));

    // Helper function to get the display value for is_premium dropdown
    const getIsPremiumDisplayValue = () => {
      if (typeof miceUpdateFormData.is_premium === 'boolean') {
        return miceUpdateFormData.is_premium ? 'yes' : 'no';
      }
      return miceUpdateFormData.is_premium;
    };

    return (
      <>
        {!edit && <FormHeader text="Basic Detail" />}
        <Spacer axis="X" size={4}></Spacer>

        <HStack
          space={MobileWindow ? 4 : 5}
          direction={MobileWindow ? "column" : "row"}
        >
          <Box flex={1}>
            <Dropdown
              name="conference_location"
              dropItems={locationOptions}
              selectedValues={
                miceFormData.additional_info.conference_location === "" ||
                  miceFormData?.additional_info.conference_location !==
                  miceUpdateFormData.additional_info.conference_location
                  ? miceUpdateFormData.additional_info.conference_location
                  : miceFormData.additional_info.conference_location
              }
              setSelectedValues={onInputChange}
              label="Conference Location"
              placeholder="Conference Location"
              isInvalid={miceErrorFormData.conference_location}
              errorMessage={miceErrorFormData.conference_location}
              important
              forceRemount={forceRemount}
            />
          </Box>
          <Box flex={1}>
            <Dropdown
              name="hotel_requirement"
              dropItems={hotelOptions}
              selectedValues={
                miceFormData.additional_info.hotel_requirement === ""
                  ? miceUpdateFormData.additional_info.hotel_requirement
                  : miceFormData.additional_info.hotel_requirement
              }
              setSelectedValues={onInputChange}
              label="Hotel Requirement"
              placeholder="Hotel Requirement"
              isInvalid={miceErrorFormData.hotel_requirement}
              errorMessage={miceErrorFormData.hotel_requirement}
              important
              forceRemount={forceRemount}
            />
          </Box>
        </HStack>
        {/* <HStack
          space={MobileWindow ? 4 : 5}
          direction={MobileWindow ? "column" : "row"}
          mt={3}
        >
          <Box flex={1}>
            <Dropdown
              name="is_premium"
              dropItems={isPremiumOptions}
              selectedValues={getIsPremiumDisplayValue()}
              setSelectedValues={onInputChange}
              label="Premium Booking"
              placeholder="Premium Booking or not"
              isInvalid={miceErrorFormData.is_premium}
              errorMessage={miceErrorFormData.is_premium}
              important
              forceRemount={forceRemount}
            />
          </Box>
          <Box flex={1}>
            <Dropdown
              name="quiz_id"
              dropItems={quizOptions}
              selectedValues={miceUpdateFormData.quiz_id}
              setSelectedValues={onInputChange}
              label="Quiz Id"
              placeholder="Quiz Id"
              isInvalid={miceErrorFormData.quiz_id}
              errorMessage={miceErrorFormData.quiz_id}
              important
              forceRemount={forceRemount}
            />
          </Box>
        </HStack> */}
        <Spacer size={MobileWindow ? 4 : 5}></Spacer>
        <HStack
          space={MobileWindow ? 1 : 5}
          direction={MobileWindow ? "column" : "row"}
          display={MobileWindow && "block"}
        >
          <Box flex={1}>
            <MultiSelectDropdown
              text="Agency"
              name="agency"
              label="Agency"
              isInvalid={miceErrorFormData.agency}
              errorMessage={miceErrorFormData.agency}
              selectedValues={miceUpdateFormData.agency}
              setSelectedValues={onInputChange}
              dropItems={agencyOptions}
              important
              // Disable other options when "Self" is selected
              isOptionDisabled={(option) => 
                miceUpdateFormData.self_agency_approval && !option.isSelfOption
              }
            />
            {MobileWindow && (
              <Flex direction="row" wrap="wrap" mt={3} space={2}>
                {miceUpdateFormData.agency.map((item, ind) => (
                  <Box key={ind} mb={1} mr={2}>
                    <CommonBadge
                      text={item.label}
                      handleSelectedValues={handleSelectedValues}
                      selectedIndex={item.id}
                    />
                  </Box>
                ))}
              </Flex>
            )}
          </Box>
          <Box flex={1}>
            <InputField
              name="business"
              value={
                // miceFormData.business === 0
                //   ? miceUpdateFormData.business
                //   : miceFormData.business
                userInfo?.company
              }
              onChange={onInputChange}
              label="Business Name"
              placeholder="Enter Business Name"
              isInvalid={miceErrorFormData.business}
              errorMessage={miceErrorFormData.business}
              important
              forceRemount={forceRemount}
              ref={childref}
              basic_details
              isDisabled={userInfo?.company && true}
            />
          </Box>
        </HStack>
        {!MobileWindow && (
          <Flex direction="row" wrap="wrap" mt={3} space={2}>
            {miceUpdateFormData.agency.map((item, ind) => (
              <Box key={ind} mb={1} mr={2}>
                <CommonBadge
                  text={item.label}
                  handleSelectedValues={handleSelectedValues}
                  selectedIndex={item.id}
                />
              </Box>
            ))}
          </Flex>
        )}
        <Spacer size={2}></Spacer>
        <HStack space={5} direction={MobileWindow ? "column" : "row"}>
          <Box flex={1} mt={MobileWindow && 2}>
            <InputField
              name="coordinator_name"
              value={
                // miceFormData.coordinator_name === ""
                //   ? miceUpdateFormData.coordinator_name
                //   : miceFormData.coordinator_name
                userInfo?.display_name
              }
              label="Coordinator Name 1"
              placeholder="Enter Coordinator Name 1"
              onChange={onInputChange}
              isInvalid={miceErrorFormData.coordinator_name}
              errorMessage={miceErrorFormData.coordinator_name}
              important
              forceRemount={forceRemount}
              ref={childref}
              basic_details
              isDisabled={userInfo?.display_name && true}
            />
          </Box>
          <Box flex={1}>
            <InputField
              name="phone"
              value={
                miceFormData.phone === ""
                  ? miceUpdateFormData.phone
                  : miceFormData.phone
              }
              label="Coordinator Number"
              placeholder="Enter Coordinator Number"
              onChange={onInputChange}
              isInvalid={miceErrorFormData.phone}
              errorMessage={miceErrorFormData.phone}
              forceRemount={forceRemount}
              ref={childref}
              basic_details
            />
          </Box>
        </HStack>
        <Spacer size={5}></Spacer>
        <HStack space={5} direction={MobileWindow ? "column" : "row"}>
          <Box flex={1}>
            <InputField
              name="email"
              value={
                // miceFormData.email === ""
                //   ? miceUpdateFormData.email
                //   : miceFormData.email
                userInfo?.email
              }
              label="Email ID 1"
              placeholder="Enter Email ID 1"
              onChange={onInputChange}
              isInvalid={miceErrorFormData.email}
              errorMessage={miceErrorFormData.email}
              important
              forceRemount={forceRemount}
              ref={childref}
              basic_details
              isDisabled={userInfo?.email && true}
            />
          </Box>
          <Box flex={1}></Box>
        </HStack>
        <Spacer size={5}></Spacer>
        <HStack space={5} direction={MobileWindow ? "column" : "row"}>
          <Box flex={1} mt={MobileWindow && 2}>
            <InputField
              name="coordinator_name_2"
              value={
                miceFormData.coordinator_name_2 === ""
                  ? miceUpdateFormData.coordinator_name_2
                  : miceFormData.coordinator_name_2
              }
              label="Coordinator Name 2"
              placeholder="Enter Coordinator Name 2"
              onChange={onInputChange}
              isInvalid={miceErrorFormData.coordinator_name_2}
              errorMessage={miceErrorFormData.coordinator_name_2}
              forceRemount={forceRemount}
              ref={childref}
              basic_details
            />
          </Box>
          <Box flex={1}>
            <InputField
              name="phone_2"
              value={
                miceFormData.phone_2 === ""
                  ? miceUpdateFormData.phone_2
                  : miceFormData.phone_2
              }
              label="Coordinator Number 2"
              placeholder="Enter Coordinator Number 2"
              onChange={onInputChange}
              isInvalid={miceErrorFormData.phone_2}
              errorMessage={miceErrorFormData.phone_2}
              forceRemount={forceRemount}
              ref={childref}
              basic_details
            />
          </Box>
        </HStack>
        <Spacer size={5}></Spacer>
        <HStack space={5} direction={MobileWindow ? "column" : "row"}>
          <Box flex={1}>
            <InputField
              name="email_2"
              value={
                miceFormData.email_2 === ""
                  ? miceUpdateFormData.email_2
                  : miceFormData.email_2
              }
              label="Email ID 2"
              placeholder="Enter Email ID 2"
              onChange={onInputChange}
              isInvalid={miceErrorFormData.email_2}
              errorMessage={miceErrorFormData.email_2}
              forceRemount={forceRemount}
              ref={childref}
              basic_details
            />
          </Box>
          <Box flex={1}></Box>
        </HStack>
        <Spacer size={5}></Spacer>
        <HStack space={5} direction={MobileWindow ? "column" : "row"}>
          <Box flex={1} mt={MobileWindow && 2}>
            <InputField
              name="coordinator_name_3"
              value={
                miceFormData.coordinator_name_3 === ""
                  ? miceUpdateFormData.coordinator_name_3
                  : miceFormData.coordinator_name_3
              }
              label="Coordinator Name 3"
              placeholder="Enter Coordinator Name 3"
              onChange={onInputChange}
              isInvalid={miceErrorFormData.coordinator_name_3}
              errorMessage={miceErrorFormData.coordinator_name_3}
              forceRemount={forceRemount}
              ref={childref}
              basic_details
            />
          </Box>
          <Box flex={1}>
            <InputField
              name="phone_3"
              value={
                miceFormData.phone_3 === ""
                  ? miceUpdateFormData.phone_3
                  : miceFormData.phone_3
              }
              label="Coordinator Number 3"
              placeholder="Enter Coordinator Number 3"
              onChange={onInputChange}
              isInvalid={miceErrorFormData.phone_3}
              errorMessage={miceErrorFormData.phone_3}
              forceRemount={forceRemount}
              ref={childref}
              basic_details
            />
          </Box>
        </HStack>
        <Spacer size={5}></Spacer>
        <HStack space={5} direction={MobileWindow ? "column" : "row"}>
          <Box flex={1}>
            <InputField
              name="email_3"
              value={
                miceFormData.email_3 === ""
                  ? miceUpdateFormData.email_3
                  : miceFormData.email_3
              }
              label="Email ID 3"
              placeholder="Enter Email ID 3"
              onChange={onInputChange}
              isInvalid={miceErrorFormData.email_3}
              errorMessage={miceErrorFormData.email_3}
              forceRemount={forceRemount}
              ref={childref}
              basic_details
            />
          </Box>
          <Box flex={1}></Box>
        </HStack>

        <Spacer size={5}></Spacer>
        <HStack space={5} direction={MobileWindow ? "column" : "row"}>
          <Box flex={1}>
            <InputField
              name="boarding_from"
              label="Boarding From"
              value={
                miceFormData.additional_info.boarding_from === ""
                  ? miceUpdateFormData.additional_info.boarding_from
                  : miceFormData.additional_info.boarding_from
              }
              onChange={onInputChange}
              placeholder="Enter Boarding From"
              isInvalid={miceErrorFormData.boarding_from}
              errorMessage={miceErrorFormData.boarding_from}
              forceRemount={forceRemount}
              ref={childref}
              basic_details
            />
          </Box>
          <Box flex={1}>
            <InputField
              name="destination_to"
              value={
                miceFormData.additional_info.destination_to === ""
                  ? miceUpdateFormData.additional_info.destination_to
                  : miceFormData.additional_info.destination_to
              }
              onChange={onInputChange}
              label="Destination To"
              placeholder="Enter Destination To"
              isInvalid={miceErrorFormData.destination_to}
              errorMessage={miceErrorFormData.destination_to}
              forceRemount={forceRemount}
              ref={childref}
              basic_details
            />
          </Box>
        </HStack>

        {/* <Spacer axis="X" size={8}></Spacer>
        <FormHeader text="Other Requirement" /> */}
        <Spacer axis="X" size={4}></Spacer>
        <HStack space={5} direction={MobileWindow ? "column" : "row"}>
          <Box flex={!MobileWindow && 1}>
            <NewTextAreaField
              name="other_requirements"
              value={
                miceFormData.other_requirements === ""
                  ? miceUpdateFormData.other_requirements
                  : miceFormData.other_requirements
              }
              onChange={onInputChange}
              label="Other Requirements"
              placeholder="Enter Other Requirements"
              isInvalid={miceErrorFormData.other_requirements}
              errorMessage={miceErrorFormData.other_requirements}
              forceRemount={forceRemount}
              ref={childref}
              basic_details
            />
          </Box>
          <Box flex={1}></Box>
        </HStack>
      </>
    );
  }
);

export default MiceBasicDetails;
